import { getArray } from '../index'

export default {
  list: (params) => getArray('expedients', params)
}
